var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSplitEditor48Filled = function SvgIconSplitEditor48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H14.6a5.31 5.31 0 0 0-5.3 5.3v18.8a5.31 5.31 0 0 0 5.3 5.3h18.8a5.31 5.31 0 0 0 5.3-5.3V14.6a5.31 5.31 0 0 0-5.3-5.3ZM12.7 33.4V14.6a1.9 1.9 0 0 1 1.9-1.9h7.7v22.6h-7.7a1.9 1.9 0 0 1-1.9-1.9Zm22.6 0a1.9 1.9 0 0 1-1.9 1.9h-7.7V12.7h7.7a1.9 1.9 0 0 1 1.9 1.9v18.8Z",
    fill: "current"
  })));
};
export default SvgIconSplitEditor48Filled;